import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "content flex-grow" }
const _hoisted_3 = { class: "close" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon-close" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "flex w-full" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { id: "content" }

import { useGlobalStore } from "@/stores/GlobalStore";
import Success from "@/components/Success.vue";
import Popup from "@/components/Popup.vue";
import Dialog from "@/components/DialogView.vue";
import Footer from "@/components/Footer.vue";
import {computed, onMounted} from "vue";
import {i18n} from "@/utilities/i18n/config";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const globalStore = useGlobalStore();
const data = computed(() => {
	return globalStore.modal.contentObject;
});

const showSuccess = computed(() => {
	return globalStore.success.show;
});

function notificationTime(notificationType:any) {
	if(notificationType === "warn") {
		return globalStore.settings.notifications.durationWarning
	}
	if(notificationType === "success") {
		return globalStore.settings.notifications.durationSuccess
	}
	if(notificationType === "error") {
		return globalStore.settings.notifications.durationError
	}
	if(notificationType === "info") {
		return globalStore.settings.notifications.durationInfo
	}
	return 0
}

const reactToReload = ()=>{
  globalStore.modal.contentObject = {};
  globalStore.modal.show = false;
};

onMounted(()=>{
  window.addEventListener('beforeunload', reactToReload);
  i18n.global.locale.value = globalStore.userPreferences.general.userLocale ?? "de";
});

return (_ctx: any,_cache: any) => {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", {
    id: "root",
    class: _normalizeClass(["flex w-full", { dark: _unref(globalStore).userPreferences.general.darkMode }])
  }, [
    _createVNode(_component_notifications, null, {
      body: _withCtx(({ item, close }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["projectNotification", item.type])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(item.text), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", { onClick: close }, _hoisted_6, 8, _hoisted_4)
            ])
          ]),
          _createElementVNode("div", {
            class: "timerBar",
            style: _normalizeStyle('--duration:'+ notificationTime(item.type))
          }, null, 4)
        ], 2)
      ]),
      _: 1
    }),
    _createVNode(Popup, { data: data.value }, null, 8, ["data"]),
    _createVNode(Dialog),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (showSuccess.value)
          ? (_openBlock(), _createBlock(Success, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_RouterView, {
          name: "LeftSidebar",
          class: ""
        })
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_RouterView),
        _createVNode(Footer)
      ])
    ])
  ], 2))
}
}

})